import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import QuantityButton from "./QuantityButton";
import ShopButton from "./ShopButton";

const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(211, 211, 211, 0.9);
  height: 4rem;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  pointer-events: ${props => (props.isVisible ? "auto" : "none")};
  z-index: 2;
  padding-left: 12px;
  padding-right: 12px;
`;

const StickyBuyButton = ({
  quantity,
  onChange,
  handleAddToCart
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 10);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <StickyBar isVisible={isVisible}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        {quantity === 0 ?
          <ShopButton
            text={"Add to order"}
            background={"#007aff"}
            containerStyles={{ ...ShopButtonStyles.button, width: "100%" }}
            buttonStyle={ShopButtonStyles.text}
            arrow={false}
            textColor={"white"}
            onClick={handleAddToCart}
          />
          :
          <QuantityButton
            initialQuantity={quantity}
            disabled={false}
            outlinedColor={"rgb(0, 122, 255)"}
            width="100%"
            background={"#007aff"}
            onChange={onChange}
            textColor={"white"}
            themeStyle={"dark"}
          />}
      </div>
    </StickyBar>
  );
};

const ShopButtonStyles = {
  button: {
    width: "380px",
    margin: "0px auto",
  },
  text: {
    fontSize: "1rem",
    lineHeight: "1rem",
  }
}

export default StickyBuyButton;